export function initSliders() {
  document.querySelectorAll("[data-slider-controls]").forEach((controls) => {
    const track = document.getElementById(controls.dataset.sliderControls)
    if (!track) return
    const prev = controls.querySelector("[data-slider-prev]")
    const next = controls.querySelector("[data-slider-next]")

    // Um so viele Bilder weiterspringen, wie gleichzeitig ganz sichtbar sind
    // (Desktop: 3, schmalere Bildschirme entsprechend weniger)
    const step = () => {
      const item = track.firstElementChild
      if (!item) return track.clientWidth
      const style = getComputedStyle(track)
      const gap = Number.parseFloat(style.columnGap) || 0
      const itemWidth = item.getBoundingClientRect().width + gap
      const visible =
        track.clientWidth -
        Number.parseFloat(style.paddingLeft) -
        Number.parseFloat(style.paddingRight) +
        gap
      const count = Math.max(1, Math.floor((visible + 1) / itemWidth))
      return count * itemWidth
    }

    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 2
      prev.disabled = track.scrollLeft <= 2
      next.disabled = track.scrollLeft >= max
    }

    prev.addEventListener("click", () =>
      track.scrollBy({ left: -step(), behavior: "smooth" }),
    )
    next.addEventListener("click", () =>
      track.scrollBy({ left: step(), behavior: "smooth" }),
    )
    track.addEventListener("scroll", update, { passive: true })
    window.addEventListener("resize", update)
    update()
  })
}
